export default "__VITE_ASSET__C7UduP2q__"